import { reaction } from 'mobx'

export function syncElementsLogo(store:any) {
    // First try to find element with syncId
    const syncElement = store.selectedElements.find(
      (el:any) => el.custom?.syncId
    );
    
    if (syncElement) {
      // Sync elements with matching syncId
      store.find((item:any) => {
        if (
          item !== syncElement &&
          item.custom?.syncId === syncElement.custom.syncId
        ) {
          // Copy all properties except 'id'
          const elementJSON = syncElement.toJSON();
          const { id, ...propsToSync } = elementJSON as { id: string; [key: string]: any };
      
          // Apply changes, only updating properties that differ
          Object.entries(propsToSync).forEach(([key, value]) => {
            const currentValue = item[key];
            if (JSON.stringify(currentValue) !== JSON.stringify(value)) {
              item.set({ [key]: value });
            }
          });
        }
      });
      return;
      
    }
    
    // If no syncId element found, check for logo elements
    const logoElement = store.selectedElements.find(
      (el:any) => el.id && el.id.includes("quickadsLogo")
    );
    
    if (logoElement) {
      // Sync elements with "quickadsLogo" in their ID
      store.find((item:any) => {
      
        if (
          item !== logoElement &&
          item.id && item.id.includes("quickadsLogo")
        ) {
          
          // Copy all properties except 'id'
          const elementJSON = logoElement.toJSON();
          const { id, ...propsToSync } = elementJSON as { id: string; [key: string]: any };
         
          // Apply changes, only updating properties that differ
          Object.entries(propsToSync).forEach(([key, value]) => {
            
            const currentValue = item[key];
            if (JSON.stringify(currentValue) !== JSON.stringify(value)) {
              item.set({ [key]: value });
            }
          });
        }
      });
    }
}


// export const setupSyncReactions = (store:any) => {
//   let lastEditElement:any = null;
  
//   // Track when an element enters/exits edit mode
//   reaction(
//     () => store.find((item:any) => item._editModeEnabled === true),
//     (editElement:any) => {
//       if (editElement) {
//         // Element entered edit mode
//         lastEditElement = editElement;
//       } else if (lastEditElement) {
//         // Element exited edit mode
        
//         // If it has a syncId, use syncElements
//         if (lastEditElement.custom?.syncId) {
//           // Store selected element temporarily to use with syncElements
//           store.selectElements([lastEditElement]);
//           syncElementsLogo(store);
//           store.selectElements([]);  // Clear selection after sync
//         } 
//         // If no syncId but ID contains "quickadsLogo"
//         else if (lastEditElement.id && lastEditElement.id.includes("quickadsLogo")) {
//           // Find and update all elements with "quickadsLogo" in their ID
//           store.find((item:any) => {
//             if (
//               item !== lastEditElement &&
//               item.id && item.id.includes("quickadsLogo")
//             ) {
//               // Copy all properties except 'id'
//               const elementJSON = lastEditElement.toJSON();
//               const { id, ...propsToSync } = elementJSON as { id: string; [key: string]: any };
              
//               // Apply changes, only updating properties that differ
//               Object.entries(propsToSync).forEach(([key, value]) => {
//                 const currentValue = item[key];
//                 if (JSON.stringify(currentValue) !== JSON.stringify(value)) {
//                   item.set({ [key]: value });
//                 }
//               });
//             }
//           });
//         }
//       }
//     }
//   );
// };